export const SectionHead = ({ eyebrow, title, children, dark = false }) => (
  <div className="max-w-2xl">
    <p className={`font-mono text-xs uppercase tracking-widest ${dark ? "text-amber-500" : "text-amber-600"}`}>{eyebrow}</p>
    <h2 className={`mt-3 font-serif text-3xl sm:text-4xl font-bold leading-tight ${dark ? "text-white" : "text-[#0B131E]"}`}>{title}</h2>
    {children ? <p className={`mt-4 text-base leading-relaxed ${dark ? "text-gray-300" : "text-gray-600"}`}>{children}</p> : null}
  </div>
);

export const Section = ({ id, children, className = "" }) => (
  <section id={id} className={`scroll-mt-16 py-16 md:py-24 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto ${className}`}>{children}</section>
);
